export const wpClassNames = {
    WP_EMAIL_CAPTURE: 'cdm-email-capture-container',
};